/**
 * Calcula o range UTC que cobre o dia atual em BRT (UTC-3).
 * Meia-noite BRT = 03:00 UTC:
 *   inicio = YYYY-MM-DDT03:00:00Z  (data BRT corrente)
 *   fim    = inicio + 24 h
 */
export function calcularRangeDiaBRT(): { inicio: string; fim: string; dataBRT: string } {
  const agora    = new Date();
  const agoraBRT = new Date(agora.getTime() - 3 * 60 * 60 * 1000);
  const dataBRT  = agoraBRT.toISOString().split('T')[0];
  const inicio   = new Date(`${dataBRT}T03:00:00.000Z`);
  const fim      = new Date(inicio.getTime() + 24 * 60 * 60 * 1000);
  return { inicio: inicio.toISOString(), fim: fim.toISOString(), dataBRT };
}

/** Tempo relativo curto a partir de um ISO timestamp (ex.: "3min atrás"). */
export function tempoRelativo(iso: string): string {
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60)    return `${diff}s atrás`;
  if (diff < 3600)  return `${Math.floor(diff / 60)}min atrás`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h atrás`;
  return `${Math.floor(diff / 86400)}d atrás`;
}
